class MobileActions {

	constructor(container) {
		container.on("itemMount", item => {
			this.bindItemEvents(container, item);
		});
	}

	bindItemEvents(container, item) {
		item.dom.addEventListener("click", e => {
			container.emit("itemEdit", item);
		});
	}
}

module.exports = MobileActions;



// WEBPACK FOOTER //
// ./resources/js/components/backend/calendar/plugins/MobileActions.js